"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTournamentScores = void 0;
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var react_1 = require("react");
var useTournamentScores = function (tournamentId) {
    var _a = (0, useQuery_1.useQuery)({
        path: keys_1.TOURNAMENT_SCORES,
        canRender: !!tournamentId,
        payload: {
            input: {
                tournamentId: tournamentId,
                pagination: {
                    page: 0,
                    limit: 100,
                },
            },
        },
        revalidateOnMount: true,
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading;
    return (0, react_1.useMemo)(function () {
        var _a;
        return ({
            data: ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.edges) || [],
            isLoading: isLoading,
            error: error,
        });
    }, [data, isLoading, error]);
};
exports.useTournamentScores = useTournamentScores;
